import { Root } from '@radix-ui/react-dialog';
import { PropsWithChildren } from 'react';
import './styles.css';

type Props = PropsWithChildren & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export default function ModalRoot({ open, onOpenChange, children }: Props) {
  return (
    <Root open={open} onOpenChange={onOpenChange} modal>
      {children}
    </Root>
  );
}
